var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance"},[_c('div',{staticClass:"maintenance-box",attrs:{"tabindex":"0"}},[_c('h3',{staticClass:"message sub",domProps:{"innerHTML":_vm._s(_vm.$t('maintenance.sub'))}})]),_c('ChatbotSorryImage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }